module.exports = __webpack_public_path__ + "img/map_Z4.2.D.04.4e132c08.svg";